import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

/** Rota legada — redireciona para login por e-mail/senha. */
export const LoginCallbackPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate("/login", { replace: true })
  }, [navigate])

  return null
}
